export default "__VITE_ASSET__M7k8aSMi__"